import React from 'react';
import TemplateAnalytics from '../../components/templates/TemplateAnalytics';
import { Helmet } from 'react-helmet';

// PROMPT-166: Template Analytics Dashboard Page for Admin

const AdminTemplateAnalytics = () => {
  return (
    <>
      <Helmet>
        <title>Template Analytics - GoSMPP Admin</title>
      </Helmet>
      
      <TemplateAnalytics isAdmin={true} />
    </>
  );
};

export default AdminTemplateAnalytics;
